import { IGeminiBalance } from '../types/Gemini.type';

export const GET_GEMINI_BALANCE = '/api/GeminiBalance';

export const GET_SYSTEM_BALANCE = '/api/SystemBalance';

export const GET_GEMINI_HEALTH = '/api/HealthCheck/CheckGeminiUrlHealth';

export const GEMINI_HEALTHY_MESSAGE = 'Gemini URL is Healthy';

export const ERROR_MESSAGE = 'Error fetching current Gemini connection status.';

const OCM_PHYSICAL = 'OCM Physical';

export const PROJECT_NAMES = {
  inputBalance: {
    transportationInput: 'Trans Input',
    storageInput: 'Storage',
    otcInput: 'NPB Buy',
    ocmTitleTradeInput: 'OCM NBP Buys',
    physicalInput: OCM_PHYSICAL,
    flexibilityInput: '',
    bioGas: '',
    totalInput: 'Total Input',
  },
  outputBalance: {
    dmAsDmCsShrinkage: 'DM Offtake',
    nonDailyMetered: 'NDM Offtake',
    unidentifiedGas: 'Unidentified Gas',
    storageOutput: 'Storage',
    otcOutput: 'NBP Sell',
    ocmTitleTradeOutput: 'OCM NBP Sells',
    physicalOutput: OCM_PHYSICAL,
    flexibilityOutput: '',
    totalOutput: 'Total Output',
  },
};

const initialItem = {
  nominated: 0,
  scheduled: 0,
};
export const initialGeminiBalance: IGeminiBalance = {
  gasDay: '',
  nominatedBalance: 0,
  scheduledBalance: 0,
  inputBalance: [
    {
      projectName: 'Trans Input',
      ...initialItem,
    },
    {
      projectName: 'Storage',
      ...initialItem,
    },
    {
      projectName: 'NPB Buy',
      ...initialItem,
    },
    {
      projectName: 'OCM NBP Buys',
      ...initialItem,
    },
    {
      projectName: OCM_PHYSICAL,
      ...initialItem,
    },
    {
      projectName: 'Total Input',
      ...initialItem,
    },
  ],
  outputBalance: [
    {
      projectName: 'DM Offtake',
      ...initialItem,
    },
    {
      projectName: 'NDM Offtake',
      ...initialItem,
    },
    {
      projectName: 'Unidentified Gas',
      ...initialItem,
    },
    {
      projectName: 'Storage',
      ...initialItem,
    },
    {
      projectName: 'NBP Sell',
      ...initialItem,
    },
    {
      projectName: 'OCM NBP Sells',
      ...initialItem,
    },
    {
      projectName: OCM_PHYSICAL,
      ...initialItem,
    },
    {
      projectName: 'Total Output',
      ...initialItem,
    },
  ],
};

export const initialSystemBalance = {
  gasDay: '',
  requestedNomination: {
    inputBalance: 0,
    outputBalance: 0,
    netBalance: 0,
  },
  scheduledNomination: {
    inputBalance: 0,
    outputBalance: 0,
    netBalance: 0,
  },
};
